import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { specMove } from "./glass";
import { Rocket, Briefcase, Coffee, Trophy, Target, Plane, Sparkles } from "lucide-react";

const FLOATERS = [
  { Icon: Rocket, pos: "left-[8%] top-[18%]", size: "h-7 w-7", dur: 9, delay: 0 },
  { Icon: Briefcase, pos: "right-[10%] top-[24%]", size: "h-6 w-6", dur: 11, delay: 1.2 },
  { Icon: Coffee, pos: "left-[14%] bottom-[20%]", size: "h-6 w-6", dur: 10, delay: 0.6 },
  { Icon: Trophy, pos: "right-[16%] bottom-[16%]", size: "h-7 w-7", dur: 12, delay: 1.8 },
  { Icon: Target, pos: "left-[26%] top-[10%]", size: "h-5 w-5", dur: 8.5, delay: 0.9 },
  { Icon: Plane, pos: "right-[26%] top-[12%]", size: "h-5 w-5", dur: 9.5, delay: 2.2 },
  { Icon: Sparkles, pos: "left-[42%] bottom-[10%]", size: "h-5 w-5", dur: 10.5, delay: 1.5 },
];

export default function CtaSection({ onContact }) {
  return (
    <section
      id="contact"
      className="relative py-36 sm:py-52 bg-black overflow-hidden"
      data-testid="cta-section"
    >
      <div
        className="absolute inset-0"
        style={{
          maskImage: "radial-gradient(ellipse 75% 70% at 50% 50%, black, transparent)",
          WebkitMaskImage: "radial-gradient(ellipse 75% 70% at 50% 50%, black, transparent)",
        }}
        aria-hidden="true"
      >
        <div
          className="absolute -inset-24 animate-drift"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.045) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.045) 1px, transparent 1px)",
            backgroundSize: "88px 88px",
          }}
        />
      </div>

      <svg
        className="absolute left-1/2 top-1/2 w-[1100px] max-w-none -translate-x-1/2 -translate-y-1/2 opacity-40"
        viewBox="0 0 1000 300"
        fill="none"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="ctaGrowthFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#22c55e" stopOpacity="0.14" />
            <stop offset="100%" stopColor="#22c55e" stopOpacity="0" />
          </linearGradient>
        </defs>
        <motion.path
          d="M20 262 C 180 252, 300 222, 430 202 S 640 132, 780 92 S 940 32, 978 20 L978 300 L20 300 Z"
          fill="url(#ctaGrowthFill)"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 1.4, duration: 1.4 }}
        />
        <motion.path
          d="M20 262 C 180 252, 300 222, 430 202 S 640 132, 780 92 S 940 32, 978 20"
          stroke="#22c55e"
          strokeWidth="2"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 2.6, ease: "easeInOut" }}
        />
        <motion.polygon
          points="972,12 990,20 972,28"
          fill="#22c55e"
          initial={{ opacity: 0, scale: 0 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 2.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        />
      </svg>

      <div className="absolute inset-0" aria-hidden="true">
        {FLOATERS.map(({ Icon, pos, size, dur, delay }, i) => (
          <motion.div
            key={i}
            className={`absolute ${pos} text-white/[0.13] hidden sm:block`}
            animate={{ y: [0, -18, 0], rotate: [0, i % 2 ? 10 : -10, 0] }}
            transition={{ duration: dur, repeat: Infinity, ease: "easeInOut", delay }}
          >
            <Icon className={size} strokeWidth={1.25} />
          </motion.div>
        ))}
      </div>

      <div className="relative max-w-5xl mx-auto px-5 sm:px-8 text-center">
        <Reveal>
          <span className="eyebrow text-[#6e6e73]">The next step</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-[-0.03em] leading-[1.04] text-white">
            Get 10x more from your time{" "}
            <span className="text-[#6e6e73]">while getting the exact results you want.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2} className="mt-10 max-w-xl mx-auto">
          <p className="text-white text-lg sm:text-xl font-medium">We'll take it from there.</p>
        </Reveal>
        <Reveal delay={0.3} className="mt-12">
          <button
            onClick={onContact}
            onMouseMove={specMove}
            data-testid="cta-talk-button"
            className="glass-spec relative rounded-full bg-white/90 backdrop-blur-xl px-12 py-5 text-base font-medium text-black border border-white/50 shadow-[inset_0_1px_1px_rgba(255,255,255,0.9),0_18px_44px_rgba(0,0,0,0.4)] transition-transform duration-300 hover:scale-[1.05] active:scale-[0.95]"
          >
            Take the first step to social growth
          </button>
        </Reveal>
      </div>
    </section>
  );
}
